import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useUserGeneralForm } from '../hook/user-general-form'
import { userGeneralValidation } from './validation'

export const useFormUserGeneral = () => {
  return useUserGeneralForm({
    mode: 'controlled',
    validate: zod4Resolver(userGeneralValidation()),
    cascadeUpdates: true,
    initialValues: {
      name: '',
      email: '',
      phone: '',
      active: 'true',
      can_order: 'trading',
      country_signup: null,
      city_signup: null,
      survey: false,
      referral_code: '',
      marking_codes: [],
      change_password: false,
      password: '',
      password_confirmation: ''
    },
    transformValues: (values) => {
      const payload = {
        name: values.name,
        email: values.email,
        phone: values.phone,
        active: values.active === 'true' ? true : false,
        can_order: values.can_order,
        country_signup: Number(values.country_signup),
        city_signup: Number(values.city_signup),
        survey: Number(values.survey),
        referral_code: values.referral_code,
        marking_codes: values.marking_codes
      }

      if (values.change_password === true) {
        payload.password = values.password
        payload.password_confirmation = values.password_confirmation
      }

      return payload
    }
  })
}